import React from 'react';
import { Layout, Menu, Dropdown, Space, Avatar } from 'antd';
import { 
  HomeOutlined, 
  AppstoreOutlined, 
  UserOutlined, 
  LoginOutlined,
  LogoutOutlined,
  GlobalOutlined,
  KeyOutlined,
  FileImageOutlined
} from '@ant-design/icons';
import { Link, useNavigate, useLocation } from 'react-router-dom';
// import { useAuth } from '../context/AuthContext';
import { useSelector, useDispatch } from 'react-redux';
import { logout_user, selectLoading, selectError, selectIsAuthenticated } from '@/store/slices/authSlice';

const { Header } = Layout;

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  // const { user, isAuthenticated, logout } = useAuth();
  const { isAuthenticated, user, loading } = useSelector(state => state.auth);
  
  // 菜单项配置
  const menuItems = [
    {
      key: '/home',
      label: <Link to="/home">首页</Link>,
      icon: <HomeOutlined />,
    },
    
    {
      key: '/web/social',
      label: <Link to="/web/social">朋友圈</Link>,
      icon: <GlobalOutlined />,
    },
    {
      key: '/web/tuku',
      label: <Link to="/web/tuku">图库</Link>,
      icon: <FileImageOutlined />,
    },
    {
      key: '/web/tasks',
      label: <Link to="/web/tasks">工作台</Link>,
      icon: <AppstoreOutlined />,
    },
    {
      key: '/web/user',
      label: <Link to="/web/user">我的</Link>,
      icon: <UserOutlined />,
    },
  ];

  // 用户下拉菜单项
  const userMenuItems = isAuthenticated ? [
    {
      key: 'profile',
      label: <Link to="/web/user">个人资料</Link>,
      icon: <UserOutlined />,
    },
    {
      key: 'key',
      label: '添加密钥',
      icon: <KeyOutlined />,
      onClick: async ()=>{
        navigate('/web/shareKey/bind');
      },
    },
    {
      key: 'logout',
      label: '退出登录',
      icon: <LogoutOutlined />,
      onClick: async ()=>{
        await dispatch(logout_user()).unwrap();
        navigate('/login/wechat');
      },
    },
  ] : [
    {
      key: 'login',
      label: <Link to="/login/wechat">登录</Link>,
      icon: <LoginOutlined />,
    },
  ];

  return (
    <Header className="navbar" style={{ 
      position: 'fixed', 
      zIndex: 1, 
      width: '100%', 
      background: '#0e1116',
      padding: 0,
      height: 64,
      display: 'flex',
      alignItems: 'center'
    }}>
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center', 
        width: '100%',
        padding: '0 20px'
      }}>
        <div style={{ 
          color: 'white', 
          fontSize: '18px', 
          fontWeight: 'bold',
          display: 'flex',
          alignItems: 'center'
        }}>
          QunhuiAI
        </div>
        
        {/* 桌面端菜单 */}
        <Menu
          theme="dark"
          mode="horizontal"
          selectedKeys={[location.pathname]}
          style={{ 
            flex: 1, 
            minWidth: 0, 
            background: '#0e1116',
            border: 'none',
            display: 'flex'
          }}
          items={menuItems}
        />
        
        {/* 用户信息区域 */}
        <div style={{ 
          display: 'flex', 
          alignItems: 'center',
          color: 'white'
        }}>
          <Dropdown 
            menu={{ items: userMenuItems }} 
            trigger={['click']}
          >
            <Space style={{ cursor: 'pointer' }}>
              <Avatar 
                size="small" 
                icon={<UserOutlined />} 
                style={{ backgroundColor: '#1890ff' }}
              />
              <span>
                {isAuthenticated && user ? (user.nickname || user.username || '用户') : '未登录'}
              </span>
            </Space>
          </Dropdown>
        </div>
      </div>
    </Header>
  );
};

export default Navbar;